import React, { useEffect, useState } from 'react';
import axios from 'axios';
import {
  Container,
  Typography,
  Paper,
  List,
  ListItem,
  ListItemText,
  Divider
} from '@mui/material';
import TextareaAutosize from '@mui/material/TextareaAutosize';



export default function SugestoesRecebidas() {
  const [sugestoes, setSugestoes] = useState([]);
  const [usuarioLogado, setUsuarioLogado] = useState('');
  const [observacoes, setObservacoes] = useState({});

  const [statusSugestoes, setStatusSugestoes] = useState({});
  
const [ocultarConcluidos, setOcultarConcluidos] = useState(true); // Oculta concluídos por padrão
const [ocultarPendentes, setOcultarPendentes] = useState(false); // Exibe pendentes por padrão





useEffect(() => {
  console.log('📡 Buscando sugestões...');

  const raw = localStorage.getItem('usuarioAtual');
  try {
    const user = JSON.parse(raw);
    const login = user?.login || '';
    setUsuarioLogado(login);

    if (login === 'gerson.souza') {
      const token = user?.token || '';
      console.log('✅ Token recuperado:', token);

      axios.get('/api/anp/sugestoes', {
        headers: {
          Authorization: `Bearer ${token}`,
          'x-usuario': login
        }
      })
      .then(res => {
        console.log('✅ Sugestões carregadas:', res.data);
        setSugestoes(res.data);
      })
      .catch(err => {
        console.error('❌ Erro ao buscar sugestões:', err);
      });
    }

  } catch (e) {
    console.error('❌ Erro ao parsear usuarioAtual:', e);
    setUsuarioLogado('');
  }
}, []);


  if (usuarioLogado !== 'gerson.souza') {
    if (!usuarioLogado) {
      return null; // ainda carregando dados do localStorage
    }

    return (
      <Container sx={{ mt: 5 }}>
        <Typography variant="h6" color="error">
          Acesso restrito.
        </Typography>
      </Container>
    );
  }

return (
  <Container maxWidth="md" sx={{ mt: 5 }}>
    <Typography variant="h4" gutterBottom>
      Sugestões Recebidas
    </Typography>

<div style={{ marginBottom: '1rem' }}>

<button
  onClick={() => setOcultarPendentes(!ocultarPendentes)}
  style={{
    backgroundColor: ocultarPendentes ? '#ccc' : '#1976d2',
    color: ocultarPendentes ? 'black' : 'white',

    marginLeft: '8px',
    padding: '6px 12px',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer'
  }}
>
  {ocultarPendentes ? '✔️ EXIBIR PENDENTES' : '✔️ OCULTAR PENDENTES'}
</button>



  <button
    onClick={() => setOcultarConcluidos(!ocultarConcluidos)}
    style={{

backgroundColor: ocultarConcluidos ? '#ccc' : '#1976d2',
color: ocultarConcluidos ? 'black' : 'white',

      padding: '6px 12px',
      border: 'none',
      borderRadius: '4px',
      cursor: 'pointer'
    }}
  >
    {ocultarConcluidos ? '✔️ EXIBIR CONCLUÍDOS' : '✔️ OCULTAR CONCLUÍDOS'}
  </button>
</div>



    {sugestoes.length === 0 ? (
      <Typography>Nenhuma sugestão registrada ainda.</Typography>
    ) : (
      <Paper elevation={3}>
        <List>
{sugestoes
  .filter((sugestao) => {
    const ehPendente = !sugestao.status || sugestao.status === 'PENDENTE';
    const ehConcluido = sugestao.status === 'CONCLUIDO';

if (ocultarPendentes && ehPendente) return false;
if (ocultarConcluidos && ehConcluido) return false;


    return true;
  })
  .map((sugestao, index) => (
    <React.Fragment key={sugestao.id}>


              <ListItem alignItems="flex-start">
                <ListItemText
                  primary={`Enviado por: ${sugestao.usuario}`}
                  secondary={(
                    <Typography
                      component="span"
                      variant="body2"
                      color="textSecondary"
                      style={{ display: 'block' }}
                    >
                      <div style={{ color: '#666', fontSize: '0.9rem' }}>
                        {new Date(sugestao.data_envio).toLocaleString()}
                      </div>

                      {/* STATUS */}
                      <div style={{
                        margin: '0.5rem 0',
                        fontWeight: 'bold',
                        color:
                          sugestao.status === 'CONCLUIDO' ? 'green' :
                          sugestao.status === 'CANCELADO' ? 'red' :
                          'orange'
                      }}>
                        Status: {sugestao.status || 'PENDENTE'}
                      </div>

                      <div style={{ marginTop: '0.5rem' }}>
                        <strong>Mensagem:</strong>
                        <TextareaAutosize
                          value={sugestao.mensagem}
                          readOnly
                          style={{
                            width: '100%',
                            padding: '8px',
                            border: '1px solid #ccc',
                            borderRadius: '4px',
                            fontSize: '0.95rem',
                            marginTop: '4px',
                            resize: 'none',
                            backgroundColor: '#f9f9f9'
                          }}
                        />

{/* IMAGENS SUGESTÃO */}
{Array.isArray(sugestao.imagens) && sugestao.imagens.length > 0 && (
  <div style={{ marginTop: '0.5rem' }}>
    <strong>Imagens enviadas:</strong>
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', marginTop: '4px' }}>
      {sugestao.imagens.map((img, idx) => (
        <div key={idx} style={{ position: 'relative', display: 'inline-block' }}>
          <img
            src={img}
            alt={`Imagem ${idx + 1}`}
            style={{
              maxWidth: '120px',
              maxHeight: '120px',
              objectFit: 'cover',
              border: '1px solid #ccc',
              borderRadius: '4px',
              cursor: 'pointer'
            }}
            onClick={() => {
              const novaJanela = window.open('', '_blank');
              novaJanela.document.write(`
                <html>
                  <head><title>Visualizar Imagem</title></head>
                  <body style="margin:0;display:flex;align-items:center;justify-content:center;background:#000;">
                    <img src="${img}" style="max-width:90%;max-height:90%;border-radius:8px;box-shadow:0 0 20px rgba(255,255,255,0.8);" />
                  </body>
                </html>
              `);
            }}
          />

          {/* BOTÃO EXCLUIR IMAGEM */}
{/* BOTÃO EXCLUIR IMAGEM */}
<button
  onClick={async () => {
    if (!window.confirm('Tem certeza que deseja excluir esta imagem?')) return;
    console.log('🗑️ Tentando excluir imagem:', img, 'da sugestão ID:', sugestao.id);
    try {
      await axios.delete(`/api/anp/sugestao/${sugestao.id}/imagem`, {
        data: { imagem: img }
      });
      console.log('✅ Imagem excluída com sucesso:', img);
      setSugestoes((prev) =>
        prev.map((s) =>
          s.id === sugestao.id
            ? { ...s, imagens: s.imagens.filter((i) => i !== img) }
            : s
        )
      );
    } catch (error) {
      console.error('❌ Erro ao excluir imagem:', error);
      alert('Erro ao excluir a imagem.');
    }
  }}
  style={{
    position: 'absolute',
    top: '-4px',
    right: '-4px',
    background: 'red',
    color: 'white',
    border: 'none',
    borderRadius: '50%',
    width: '20px',
    height: '20px',
    cursor: 'pointer',
    fontSize: '12px',
    lineHeight: '20px',
    textAlign: 'center'
  }}
>
  ×
</button>

        </div>
      ))}
    </div>
  </div>
)}



                      </div>

                      {/* INTERAÇÃO */}
                      {(!sugestao.status || sugestao.status === 'PENDENTE') && (
                        <div style={{ width: '100%', marginTop: '0.5rem' }}>
                          <TextareaAutosize
                            minRows={2}
                            placeholder="Observações..."
                            value={observacoes[sugestao.id] || ''}
                            onChange={(e) =>
                              setObservacoes((prev) => ({
                                ...prev,
                                [sugestao.id]: e.target.value
                              }))
                            }
                            style={{
                              width: '100%',
                              padding: '8px',
                              fontSize: '0.95rem',
                              borderRadius: '4px',
                              border: '1px solid #ccc',
                              marginBottom: '0.5rem',
                              resize: 'none'
                            }}
                          />

                          <div>
                            <button
                              style={{ marginRight: '8px' }}
                              onClick={async () => {
                                try {
                                  await axios.put(`/api/anp/sugestao/${sugestao.id}`, {
                                    status: 'CONCLUIDO',
                                    observacao: observacoes[sugestao.id] || ''
                                  });
                                  const novasSugestoes = sugestoes.map((s) =>
                                    s.id === sugestao.id
                                      ? { ...s, status: 'CONCLUIDO', observacao: observacoes[sugestao.id] }
                                      : s
                                  );
                                  setSugestoes(novasSugestoes);
                                  console.log('✅ CONCLUÍDO:', sugestao.id, observacoes[sugestao.id]);
                                } catch (e) {
                                  alert('Erro ao atualizar sugestão.');
                                }
                              }}
                            >
                              CONCLUÍDO
                            </button>
                            <button
                              onClick={async () => {
                                try {
                                  await axios.put(`/api/anp/sugestao/${sugestao.id}`, {
                                    status: 'CANCELADO',
                                    observacao: observacoes[sugestao.id] || ''
                                  });
                                  const novasSugestoes = sugestoes.map((s) =>
                                    s.id === sugestao.id
                                      ? { ...s, status: 'CANCELADO', observacao: observacoes[sugestao.id] }
                                      : s
                                  );
                                  setSugestoes(novasSugestoes);
                                  console.log('❌ CANCELADO:', sugestao.id, observacoes[sugestao.id]);
                                } catch (e) {
                                  alert('Erro ao atualizar sugestão.');
                                }
                              }}
                            >
                              CANCELADO
                            </button>
                          </div>
                        </div>
                      )}

                      {/* BOTÃO REABRIR */}
                      {(sugestao.status === 'CONCLUIDO' || sugestao.status === 'CANCELADO') && (
                        <div style={{ marginTop: '0.5rem' }}>
                          <button
                            onClick={() => {
                              const novasSugestoes = sugestoes.map((s) =>
                                s.id === sugestao.id
                                  ? { ...s, status: undefined }
                                  : s
                              );
                              setSugestoes(novasSugestoes);
                              console.log('🔄 REABERTO:', sugestao.id);
                            }}
                          >
                            REABRIR
                          </button>
                        </div>
                      )}

                      {/* BOTÃO EXCLUIR */}
                      <div style={{ marginTop: '0.5rem' }}>
                        <button
                          style={{
                            color: 'red',
                            border: '1px solid red',
                            padding: '4px 8px',
                            borderRadius: '4px'
                          }}
                          onClick={async () => {
                            if (!window.confirm('Tem certeza que deseja excluir esta sugestão?')) return;
                            try {
                              await axios.delete(`/api/anp/sugestao/${sugestao.id}`);
                              const novas = sugestoes.filter(s => s.id !== sugestao.id);
                              setSugestoes(novas);
                              console.log('🗑️ Sugestão excluída:', sugestao.id);
                            } catch (e) {
                              alert('Erro ao excluir sugestão.');
                            }
                          }}
                        >
                          EXCLUIR
                        </button>
                      </div>
                    </Typography>
                  )}
                />
              </ListItem>
              {index < sugestoes.length - 1 && <Divider component="li" />}
            </React.Fragment>
          ))}
        </List>
      </Paper>
    )}
  </Container>
);




}
